import moment from 'moment'
import { useLocaleState } from '@merchant-portal/merchant-portal-base'
import { Languages } from '../models/languages'

const DAY_MONTH_YEAR = 'DD.MM.YYYY'
const YEAR_MONTH_DAY = 'YYYY-MM-DD'

const { DANISH, FINNISH, NORWEGIAN, SWEDISH } = Languages

export const selectDateFormat = language => {
  switch (language) {
    case FINNISH:
    case DANISH:
    case NORWEGIAN:
      return DAY_MONTH_YEAR
    case SWEDISH:
      return YEAR_MONTH_DAY
    default:
      return YEAR_MONTH_DAY
  }
}

export const datePickerDateFormat = language => {
  switch (language) {
    case FINNISH:
    case DANISH:
    case NORWEGIAN:
      return 'dd.MM.yyyy'
    case SWEDISH:
    default:
      return 'yyyy-MM-dd'
  }
}

export const calculateLinkExpirationDate = date => {
  const { language } = useLocaleState()
  return moment(date).add(30, 'days').format(selectDateFormat(language))
}

export const prettyPrintDateTime = date => {
  const { language } = useLocaleState()
  return (
    (!!date && moment(date).format(`${selectDateFormat(language)} HH:mm`)) || ''
  )
}

const formatDate = (date, language) =>
  (!!date && moment(date).format(selectDateFormat(language))) || ''

export const prettyPrintDate = date => {
  const { language } = useLocaleState()
  return formatDate(date, language)
}

export const prettyPrintPeriod = (from, to, language) =>
  `${formatDate(from, language)} - ${formatDate(to, language)}`
